module.exports = "/_next/static/images/en_2-0e7ee3e4549613d4d39eb8ba02825886.jpg";